import React from 'react'

const HelloEarth = () => {
  return <div>Hello, Earth!</div>
}

export default HelloEarth
